import React, {useEffect} from "react";
import Strings from "../../../config/Strings";
import googlePlay from "../../../../assets/images/Badge-GooglePlay@2x.png";
import appStore from "../../../../assets/images/Badge-AppStore@2x.png";
import GlobalConstants from "../../../config/GlobalConstants";
import {useHistory, useLocation} from "react-router";
import {authCheck} from "../../../util/authCheck";

export default function McDonaldsRedemptionSuccess() {

    const history = useHistory();
    const coupon = JSON.parse(sessionStorage.getItem('ls.mcdonalds'));
    const location = useLocation();

    //ROUTING
    useEffect(() => {
        if (!authCheck()) {
            history.push("/" + GlobalConstants.APP_PATH + "mcdonalds/authenticate");
        }

        if (coupon == null) {
            history.push("/" + GlobalConstants.APP_PATH + "mcdonalds");
        }

        if (location !== undefined && location.hash !== "") {
            const element = document.getElementById(location.hash);
            if (element) {
                element.scrollIntoView({behavior: "smooth", block: "center"});
            }
        }
    }, [history, coupon, location]);

    if (coupon == null) {
        history.push("/" + GlobalConstants.APP_PATH + "mcdonalds");
    }

    if (!authCheck()) {
        history.push("/" + GlobalConstants.APP_PATH + "mcdonalds/authenticate");
    }

    //Rendering
    return (
        <>
            <div className="mcdonalds-container">
                <div className="mcdonalds-header-overlay">
                    <div>
                        <img src={"https://cdn.tigerbooks.de/promotion/mcdonalds/header.png"}
                             alt={"header"}/>
                    </div>
                </div>
                <p className="mcdonalds-info" style={{textAlign: "center"}} dangerouslySetInnerHTML={{__html: Strings.MCDONALDS_SUCCESS_INFO}} />

                <div className="mcdonalds-section-text-content">

                    <p dangerouslySetInnerHTML={{__html: Strings.MCDONALDS_SUCCESS_INSTALL_APP_HINT}} />

                    <div className={"d-flex justify-content-between mb-3"}>
                        <a className="app-icon icon-right" href="https://apps.apple.com/de/app/tigertones/id1269083572">
                            <img src={appStore} alt={"tigertones im Apple App Store"}/>
                        </a>
                        <a className="app-icon icon-left" href={"market://launch?id=com.tigermedia.TigerAudio"}>
                            <img src={googlePlay} alt={"tigertones im Google Play Store"} />
                        </a>
                    </div>
                </div>
            </div>
        </>
    )

}